import { createFileRoute } from '@tanstack/react-router';
import { TemplatesIndexPage } from '../../templates/index-page.js';

export const Route = createFileRoute('/templates/')({ component: TemplatesIndexPage });
